import { common } from '@neo-one/client-common';
export var TriggerType;
(function (TriggerType) {
    TriggerType[TriggerType["Verification"] = 0] = "Verification";
    TriggerType[TriggerType["Application"] = 16] = "Application";
})(TriggerType || (TriggerType = {}));
export const NULL_ACTION = {
    blockIndex: -1,
    blockHash: common.ZERO_UINT256,
    transactionIndex: -1,
    transactionHash: common.ZERO_UINT256,
};

//# sourceMappingURL=vm.js.map
